import { Link } from 'react-router-dom';
import { animeCategories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 mb-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-3 group">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-lg text-primary-500"></i>
                </div>
                <span className="font-heading text-lg text-primary-500 whitespace-nowrap">羞羞动漫</span>
              </Link>
              <p className="text-xs text-foreground-600 leading-relaxed">
                最全国产精品动漫在线平台<br />
                每日更新，免费观看
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-3 whitespace-nowrap">动漫分类</h4>
              <div className="flex flex-col gap-2">
                {animeCategories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-3 whitespace-nowrap">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
                <Link to="/category/mitao" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">蜜桃动漫</Link>
                <Link to="/category/guochan" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">国产精品</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-medium text-foreground-900 mb-3 whitespace-nowrap">联系方式</h4>
              <div className="flex flex-col gap-2">
                <span className="text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-mail-line mr-1"></i>contact@xiuxiudongman.com
                </span>
                <span className="text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-customer-service-2-line mr-1"></i>在线客服
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2026 羞羞动漫网站 版权所有 | 51动漫国产精品入口
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}